export default __webpack_public_path__ + "static/media/group-7068.65bae0a3.png";